// src/components/ErrorBoundary.js
import React from 'react';

export class ErrorBoundary extends React.Component {
    state = { hasError: false };
    static getDerivedStateFromError() { return { hasError: true }; }
    render() {
        if (this.state.hasError) {
            return <div style={{ padding: '1rem', color: 'red' }}>
                Something went wrong. Please refresh or try again later.
            </div>;
        }
        return this.props.children;
    }
}
